import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import { ListItem, List, ListItemIcon, ListItemText } from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import Badge from '@material-ui/core/Badge';

//Components & Hooks
import { useHistory } from 'react-router-dom';
import { useGeneral } from '../../Context/GeneralContext';

const RecursiveListNode = ({
    isChild,
    node,
    drawerOpen,
    openItem,
    selectedItem,
    setDrawerOpen,
    setOpenItem,
    setSelectedItem,
}) => {
    const { children, icon, id, path, text } = node;
    const isSelected = id === selectedItem;
    const isOpen = openItem === id;

    const history = useHistory();
    const { notify } = useGeneral();
    const IconComponent = icon;

    const itemClass = ['menu-list-item-root', drawerOpen ? 'menu-list-item--open' : '',
        isSelected ? 'menu-list-item--selected' : ''].filter(Boolean).join(' ');
    const iconClass = ['menu-list-icon', isSelected || isOpen ? 'menu-list-icon--active' : '']
        .filter(Boolean).join(' ');

    const handleOpen = (itemId) => {
        setOpenItem(itemId);
        setSelectedItem(itemId);
        setDrawerOpen(true);
    };

    const handleClickList = (itemId) => {
        if (!isChild) {
            setOpenItem('');
        }
        setSelectedItem(itemId);
        history.push(path);
    };

    if (!children) {
        return (
            <ListItem
                button
                onClick={() => handleClickList(id)}
                className={itemClass}
                classes={{ selected: 'menu-list-item--selected' }}
                selected={isSelected}
            >
                <ListItemIcon className={iconClass}>
                    <IconComponent />
                </ListItemIcon>
                <ListItemText primary={text} className="menu-list-text" />
                {node.id === 'paros' && (
                    <Badge
                        badgeContent={notify}
                        overlap="circular"
                        className="menu-notify-badge"
                        color="error"
                    />
                )}
            </ListItem>
        );
    }

    return (
        <div className={isOpen ? 'menu-item__collapse-wrapper' : undefined}>
            <ListItem
                button
                onClick={() => handleOpen(id)}
                className={itemClass}
                classes={{ selected: 'menu-list-item--selected' }}
                selected={isSelected}
            >
                <ListItemIcon className={iconClass}>
                    <IconComponent />
                </ListItemIcon>
                <ListItemText primary={text} className="menu-list-text" />
            </ListItem>
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding className="menu-list-nested">
                    {children.map((item, idx) => (
                        <RecursiveListNode
                            node={item}
                            key={idx + id}
                            selectedItem={selectedItem}
                            setSelectedItem={setSelectedItem}
                            isChild={true}
                        />
                    ))}
                </List>
            </Collapse>
        </div>
    );
};

RecursiveListNode.propTypes = {
    node: PropTypes.shape({
        children: PropTypes.array,
        icon: PropTypes.func,
        id: PropTypes.string,
        path: PropTypes.string,
        text: PropTypes.string,
    }),
    selectedItem: PropTypes.string,
    setSelectedItem: PropTypes.func,
    openItem: PropTypes.string,
    drawerOpen: PropTypes.bool,
    setDrawerOpen: PropTypes.func,
    setOpenItem: PropTypes.func,
    isChild: PropTypes.bool,
};

export default RecursiveListNode;
